import "./address-book-missing-item.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { infoCircle } from "@tql/ui-components-react/untitled/icons";

export type AddressBookMissingItemProps = {
	/** Callback invoked when user clicks the recovery button */
	onRetry: () => void;
};

/**
 * Renders a standardized error state when an Address Book item cannot be found.
 * Provides clear messaging and a recovery action button.
 */
export const AddressBookMissingItem = ({
	onRetry,
}: Readonly<AddressBookMissingItemProps>) => {
	return (
		<div
			className={"address-book-missing-item"}
			data-testid={"address-book-missing-item"}
		>
			<div className={"address-book-missing-item-content"}>
				<SvgIcon
					className={"address-book-missing-item-icon"}
					data-testid={"address-book-missing-item-icon"}
					icon={infoCircle}
				/>
				<h2
					className={"address-book-missing-item-heading"}
					data-testid={"address-book-missing-item-heading"}
				>
					Address Not Found
				</h2>
				<p
					className={"address-book-missing-item-message"}
					data-testid={"address-book-missing-item-message"}
				>
					The selected address book item could not be found. It may have been
					deleted or is no longer available.
				</p>
				<div className={"address-book-missing-item-button-container"}>
					<Button
						data-testid={"address-book-missing-item-return-btn"}
						onClick={onRetry}
					>
						Return to Address Book
					</Button>
				</div>
			</div>
		</div>
	);
};
